import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, isRef as _isRef, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["tabindex", "onClick", "onKeydown"]

import draggable from 'vuedraggable';
    import {PropType} from 'vue';
    import {Skill} from '../types/Skill';
    import {useSkillsBuilder} from '../composable/useSkillsBuilder';

    type TagStyles = {
        'draggable-skill': boolean;
        'm-tag_inactive': boolean;
        'm-tag_draggable': boolean;
        'm-tag_secondary': boolean;
    };

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DraggableSkills',
  props: {
        skills: {type: Array as PropType<Skill[]>, required: true},
        maxCount: {type: Number, default: -1},
        placeholderCount: {type: Number, default: 0},
        showRemoveButton: {type: Boolean, default: false},
        isOptionalSkills: Boolean,
    },
  emits: ["change"],
  setup(__props, { emit: __emit }) {

    const props = __props;

    const emits = __emit;

    function getTagStyle(skill: Skill): TagStyles {
        return {
            'draggable-skill': !skill.disabled,
            'm-tag_inactive': skill.disabled,
            'm-tag_draggable': !skill.disabled,
            'm-tag_secondary': props.isOptionalSkills,
        };
    }

    const {dragging, skillsModel} = useSkillsBuilder(props);

    function clone(skill: Skill): Skill {
        return {name: skill.name, disabled: skill.disabled, placeholder: skill.placeholder};
    }

    function put(to: HTMLElement, from: HTMLElement, item: HTMLElement): boolean {
        const draggedItemName = item.innerText.trim();
        if (props.maxCount === -1) {
            return false;
        }
        return props.skills.length < props.maxCount && props.skills.filter((s) => s.name === draggedItemName).length === 0;
    }

    function removeSkill(skill: Skill): void {
        if (skill.disabled) {
            return;
        }
        const skillToRemove = skillsModel.value.find((s) => s.name === skill.name);
        if (skillToRemove) {
            const indexToRemove = skillsModel.value.indexOf(skillToRemove);
            skillsModel.value.splice(indexToRemove, 1);
            emitsChangeEvent();
        }
    }

    function emitsChangeEvent() {
        emits(
            'change',
            skillsModel.value.filter((s) => !s.placeholder),
        );
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_icon = _resolveComponent("joy-icon")!

  return (_openBlock(), _createBlock(_unref(draggable), {
    modelValue: _unref(skillsModel),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(skillsModel) ? (skillsModel).value = $event : null)),
    class: "m-tag-list skills",
    group: {put: put, pull: true},
    clone: clone,
    "item-key": "name",
    draggable: ".draggable-skill",
    "data-testid": "draggable-skills",
    onStart: _cache[1] || (_cache[1] = ($event: any) => (dragging.value = true)),
    onEnd: _cache[2] || (_cache[2] = ($event: any) => (dragging.value = false)),
    onChange: emitsChangeEvent
  }, {
    item: _withCtx(({element, index}) => [
      (element.placeholder)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            (_openBlock(), _createElementBlock("span", {
              key: element.name,
              class: "m-tag m-tag_secondary skills__placeholder"
            }))
          ]))
        : (!element.disabled)
          ? (_openBlock(), _createElementBlock("span", {
              key: `${element.name}_${index}`,
              class: _normalizeClass(["m-tag", getTagStyle(element)]),
              tabindex: !element.disabled ? 0 : -1,
              "data-testid": "draggable-skill",
              onClick: ($event: any) => (removeSkill(element)),
              onKeydown: _withKeys(($event: any) => (removeSkill(element)), ["enter"])
            }, [
              _createVNode(_component_joy_icon, {
                name: "bars",
                color: 'white',
                class: "m-tag_icon_draggable"
              }),
              _createTextVNode(" " + _toDisplayString(element.name) + " ", 1),
              (__props.showRemoveButton)
                ? (_openBlock(), _createBlock(_component_joy_icon, {
                    key: 0,
                    name: "cancel"
                  }))
                : _createCommentVNode("", true)
            ], 42, _hoisted_2))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "group"]))
}
}

})